import React, { memo } from "react";
import * as PropTypes from "prop-types";
import PivotTable from "../../table/PivotTable";

const ChangeByGniGroupTable = props => (
  <PivotTable
    titles={[
      {
        key: "items",
        title: "",
        columnSpan: 1
      },
      {
        key: "years",
        title: "",
        columnSpan: 3,
        groupEnd: true
      },
      {
        key: "2020-2025",
        title: "5-yr change</br >(2020 to 2025)",
        columnSpan: 2,
        groupEnd: true
      },
      {
        key: "2025-2030",
        title: "5-yr change</br >(2025 to 2030)",
        columnSpan: 2
      }
    ]}
    columnKey="year"
    columnDefinitions={[
      {
        value: "2020"
      },
      {
        value: "2025"
      },
      {
        value: "2030",
        groupEnd: true
      },
      {
        value: "# (2020-2025)",
        label: "#"
      },
      {
        value: "% (2020-2025)",
        label: "%",
        percentage: true,
        groupEnd: true
      },
      {
        value: "# (2025-2030)",
        label: "#"
      },
      {
        value: "% (2025-2030)",
        label: "%",
        percentage: true
      }
    ]}
    rowKey="area"
    rowDefinitions={[
      {
        value: "Low-Income (LIC)",
        label: "LIC"
      },
      {
        value: "Lower-Middle-Income (L-MIC)",
        label: "L-MIC"
      },
      {
        value: "Upper-Middle-Income (U-MIC)",
        label: "U-MIC"
      },
      {
        value: "Total",
        total: true
      }
    ]}
    data={props.data}
  />
);

ChangeByGniGroupTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(ChangeByGniGroupTable);
